import gql from 'graphql-tag';
import { client } from '../../apollo';
import { loadingAlert } from '../../Common/alerts';
import { copy, getAmount } from '../../Common/utils';

export async function zwalletTransferGraphQL(data) {
    const TRANSFER_TED = gql`
        mutation TransferTedoc($transfer: TransferTedDocInput!) {
            transferTedoc(data: $transfer) {
                receipt {
                    sender {
                        name
                        accountNumber
                        document
                    }
                    receiver {
                        bankNumber
                        name
                        accountNumber
                        agency
                        document
                    }
                    amount
                }
            }
        }
    `;

    const { payload, user } = data;

    const accountNumber = user.zwalletUser.accounts[0].accountNumber
    payload['transfer']['userAccount'] = String(accountNumber)
    const payload_copy = copy(payload)
    payload_copy['transfer']['amount'] = getAmount(payload_copy['transfer']['amount']);
    const variables = payload_copy

    try {
        loadingAlert("Transferência", "Enviando transferência")
        const { data } = await client.mutate({
            mutation: TRANSFER_TED,
            variables
        });

        return data.transferTedoc;
    } catch(error) {
        const msg = error.message.replace("GraphQL error: ", "")
        console.log(msg);
        throw msg
    }
}

export async function bankListGraphQL() {
    const QUERY = gql`
        query {
            banks {
                code
                name
            }
        }
    `;

    try {
        const { data } = await client.query({
            query: QUERY
        });

        return data
    } catch(error) {
        const msg = error.message.replace("GraphQL error: ", "")
        console.log(msg);
        throw msg
    }
}




// WEBPACK FOOTER //
// ./src/ZWallet/Transfer/graphql.js